import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const TeamsTabLandingExperienceContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "teamstablandingexperiencecontainer" */ "./TeamsTabLandingExperienceContainer")).then((bundle)=>{
        return {
            default: bundle.TeamsTabLandingExperienceContainer
        };
    });
export const LazyTeamsTabLandingExperienceContainer = /*#__PURE__*/ lazy(TeamsTabLandingExperienceContainerLazyLoader);
